var React = require('react');

function Save (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M434 130l-84-84a48 48 0 0 0-33.9-14H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V163.9a48 48 0 0 0-14-34zM224 416a64 64 0 1 1 0-128 64 64 0 0 1 0 128zm96-304.5V212a12 12 0 0 1-12 12H76a12 12 0 0 1-12-12V108a12 12 0 0 1 12-12h228.5a12 12 0 0 1 8.5 3.5l3.5 3.5a12 12 0 0 1 3.5 8.5z"}));
}

Save.defaultProps = {"aria-hidden":"true","data-icon":"save","viewBox":"0 0 448 512"};

module.exports = Save;

Save.default = Save;
